export const enum ReclamationStep {
  Reasons = 'reasons',
  Solutions = 'solutions',
  AdditionalInfo = 'additional-info',
}

export const enum EditReclamationStep {
  EditReasons = 'edit_reasons',
  EditSolutions = 'edit_solutions',
  EditAdditionalInfo = 'edit_additional-info',
}

export enum ReclamationDislikeReason {
  NotInterest = 'no_demand2.lost_interest',
}

export const enum TrackingEvent {
  ReclamationDrawerClick = 'reclamation-drawer_click',
  ReclamationRecapCardListClick = 'reclamation-recap-card-list_click',
  ReclamationRequestOrderOverviewClick = 'reclamation-request-order-overview_click',
  ReclamationRecapOrderOverviewClick = 'reclamation-recap-order-overview_click',
}

export const enum TrackingEventType {
  CancellationSingle = 'cancellation_single',
  CancellationMultiple = 'cancellation_multiple',
  ClaimSingle = 'claim_single',
  ClaimMultiple = 'claim_multiple',
}

export const enum TrackingEventElement {
  Link = 'link',
  Button = 'button',
  Icon = 'icon',
  BackdropDrawer = 'backdrop-drawer',
}

export const enum TrackingEventInteraction {
  DeleteClaim = 'delete_claim',
  EditClaimReasons = 'edit_claim_reasons',
  EditClaimSolutions = 'edit_claim_solutions',
  EditClaimAdditionalInfo = 'edit_claim_additional-info',
}
